// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingOverviewPrice_root__p8hCz","sectionSubtitle":"ListingOverviewPrice_sectionSubtitle__3BFxE","priceRow":"ListingOverviewPrice_priceRow__1mdBK"};